import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

function keyOf(assetType, symbol, coinId) {
  return assetType === "crypto" ? `crypto:${coinId}` : `currency:${symbol}`;
}

export function useFavorites() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["favorites"],
    queryFn: async () => (await api.get("/favorites")).data.favorites,
  });
  const favs = data || [];
  const map = {};
  favs.forEach((f) => { map[keyOf(f.asset_type, f.symbol, f.coin_id)] = f.id; });

  const mut = useMutation({
    mutationFn: async ({ action, payload, id }) => {
      if (action === "add") return (await api.post("/favorites", payload)).data;
      return (await api.delete(`/favorites/${id}`)).data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["favorites"] });
      qc.invalidateQueries({ queryKey: ["watchlist"] });
    },
    onError: (e) => toast.error(formatApiError(e)),
  });

  const isFav = (assetType, symbol, coinId) => !!map[keyOf(assetType, symbol, coinId)];

  const toggle = (asset) => {
    const k = keyOf(asset.asset_type, asset.symbol, asset.coin_id);
    if (map[k]) {
      mut.mutate({ action: "remove", id: map[k] });
    } else {
      mut.mutate({ action: "add", payload: asset });
      toast.success(`${asset.symbol} added to watchlist`);
    }
  };

  return { favs, isFav, toggle };
}
